import { gql } from '@apollo/client';

export const MUTATION_GENERATE_MUNICIPALITY_XLSX = gql`
  mutation GenerateMunicipalityXLSX(
    $municipalityCode: String!
    $comparativeMunicipalityCodes: [String!]
    $language: String
  ) {
    generateMunicipalityXLSX(
      municipality_code: $municipalityCode
      comparative_municipality_codes: $comparativeMunicipalityCodes
      language: $language
    ) {
      url
    }
  }
`;
